export enum PortalRequestType {
  NewUser,
  ReferralUser,
  WorkComp
}

export interface PortalRequest {
    userIdSub: string;
    accountTypeId: number;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    requestDate: Date;
    requestType: PortalRequestType;
}
